/**
 * Table of contents — items is an array of { id, label }.
 */
export function Toc({ items }) {
  return (
    <nav className="bg-paper-warm border border-rule px-9 py-7 my-0 mb-16 columns-2 gap-12 [column-rule:1px_dotted_var(--rule)]">
      <h2 className="[column-span:all] font-display font-medium text-[1.1rem] tracking-wider uppercase text-accent pb-2.5 border-b border-rule mb-4">
        Contents
      </h2>
      <ol className="list-none p-0 m-0" style={{ counterReset: 'toc' }}>
        {items.map(({ id, label }) => (
          <li
            key={id}
            className="py-1 flex items-baseline gap-2.5 break-inside-avoid"
            style={{ counterIncrement: 'toc' }}
          >
            <span className="font-mono text-[10px] text-accent tracking-wider min-w-[24px] toc-num" />
            <a
              href={`#${id}`}
              className="text-ink no-underline flex-1 border-b border-dotted border-transparent hover:text-accent hover:border-accent transition-colors"
            >
              {label}
            </a>
          </li>
        ))}
      </ol>
      <style>{`
        ol li .toc-num::before { content: counter(toc, decimal-leading-zero); }
      `}</style>
    </nav>
  );
}
